import React from "react";
import "./GynaeSection.css";
import gynaeImg from "../assets/Gynae/1.jpg";
import { Link } from "react-router-dom";

const GynaeSection = () => {
  return (
    <section className="gynae-section">

      <div className="container gynae-wrapper">

        {/* LEFT CONTENT */}
        <div className="gynae-content">

          <span className="gynae-tag">Women’s Health Care</span>

          {/* ✅ SEO Heading */}
          <h2>
            Best <span>Gynaecologist in Ambala</span> <br />
            for Every Stage of Life
          </h2>

          <p>
            At Amaanat IVF & Fertility, we provide comprehensive
            gynaecological care tailored to women of all ages. From
            routine checkups to advanced treatments, our team ensures
            personalized, compassionate, and confidential care.
          </p>

          <ul className="gynae-list">
            <li>✔ Menstrual & Hormonal Disorders</li>
            <li>✔ Pregnancy & Antenatal Care</li>
            <li>✔ PCOS / PCOD Management</li>
            <li>✔ Infertility Evaluation & Treatment</li>
          </ul>

          <div className="gynae-actions">

            {/* ✅ Internal Linking Boost */}
            <Link
              to="/bookappointment"
              className="about-btn"
              title="Book Gynaecology Consultation in Ambala"
            >
              Book Consultation
            </Link>

            <Link
              to="/services/gynae"
              className="btn-outline"
              title="Gynaecology Services in Ambala"
            >
              Find Out More
            </Link>

          </div>

        </div>

        {/* RIGHT IMAGE */}
        <div className="gynae-image">
          <img
            src={gynaeImg}
            alt="Best Gynaecologist in Ambala - Women Health Care"
            loading="lazy"
          />
        </div>

      </div>

    </section>
  );
};

export default GynaeSection;